export default __webpack_public_path__ + "static/126-min-min-13d97e102463f99401c3b7100d13dac8.jpg";